import React from "react";
import "./HTML_MAIN_CSS.css";

const HTMLFilePaths = () => {
  return (
    <div className="html-container">
      <h1>HTML – File Paths</h1>

      {/* 1. Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          File paths in HTML define the location of files (images, CSS, scripts, etc.) that the HTML document references.
          Correct file paths are essential to ensure your resources load properly.
        </p>
      </section>

      {/* 2. Types of File Paths */}
      <section id="types">
        <h2>2. Types of File Paths</h2>
        <ul>
          <li><strong>Absolute Path:</strong> Specifies the full URL or location from the root.</li>
          <li><strong>Relative Path:</strong> Specifies the path relative to the current HTML file.</li>
        </ul>
      </section>

      {/* 3. Absolute Paths */}
      <section id="absolute-paths">
        <h2>3. Absolute Paths</h2>
        <p>Absolute paths point to a specific location, either on the web or local system:</p>
        <pre>
          <code>{`<!-- Linking an external website CSS -->
<link rel="stylesheet" href="https://example.com/styles.css">

<!-- Linking an image from a full URL -->
<img src="https://example.com/images/logo.png" alt="Logo">`}</code>
        </pre>
      </section>

      {/* 4. Relative Paths */}
      <section id="relative-paths">
        <h2>4. Relative Paths</h2>
        <p>Relative paths are relative to the location of the HTML file:</p>
        <ul>
          <li><strong>Same folder:</strong> <code>file.css</code> or <code>image.png</code></li>
          <li><strong>Parent folder:</strong> <code>../styles/file.css</code></li>
          <li><strong>Subfolder:</strong> <code>images/logo.png</code></li>
        </ul>
        <pre>
          <code>{`<!-- CSS in same folder -->
<link rel="stylesheet" href="style.css">

<!-- CSS in parent folder -->
<link rel="stylesheet" href="../style.css">

<!-- Image in subfolder -->
<img src="images/photo.jpg" alt="Photo">`}</code>
        </pre>
      </section>

      {/* 5. Root-relative Paths */}
      <section id="root-relative">
        <h2>5. Root-relative Paths</h2>
        <p>Root-relative paths start from the root of the website:</p>
        <pre>
          <code>{`<img src="/assets/images/logo.png" alt="Logo">`}</code>
        </pre>
      </section>

      {/* 6. File Path Best Practices */}
      <section id="best-practices">
        <h2>6. Best Practices</h2>
        <ul>
          <li>Organize files in a clear folder structure (e.g., css/, js/, images/).</li>
          <li>Prefer relative paths for local development.</li>
          <li>Use lowercase file names and avoid spaces.</li>
          <li>Test paths thoroughly to avoid broken links.</li>
          <li>Use root-relative paths for larger projects for easier portability.</li>
        </ul>
      </section>

      {/* 7. Summary */}
      <section id="summary">
        <h2>7. Summary</h2>
        <ul>
          <li>Absolute paths point to a specific URL or location.</li>
          <li>Relative paths point to files relative to the current HTML file.</li>
          <li>Root-relative paths start from the root folder.</li>
          <li>Always organize and verify paths to prevent broken resources.</li>
        </ul>
      </section>
    </div>
  );
};

export default HTMLFilePaths;
